// extracted by mini-css-extract-plugin
module.exports = {"container":"_2JlPi","wrapper":"_1qAZz","icon":"b_rdC"};